import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export interface ReviseEmailPayload {
  current_body: string
  revision_prompt: string
  subject?: string
  reply_to_syncbox_message_id?: string
  household_id?: string
  contact_id?: string
  email_integration_id?: string
  from_email?: string
}

export interface ReviseEmailResponse {
  revised_body: string
  subject?: string
}

export function reviseEmail(context: ApiContext, payload: ReviseEmailPayload) {
  return apiContextFetch<ReviseEmailResponse>(context, `syncbox/email_messages/revise`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
}
